import { Typography, Button, Row, Col }  from 'antd'
import { useState, useEffect } from 'react'
import Breakpoint from '../../enums/breakpoint.enum.js'
import LatestPosts from '../latestPosts/latestPosts.component.js'
import useWidth from '../../hooks/useWidth.hook.js'


const { Text, Paragraph } = Typography

export const BiobeatConfirm = ({sendBPmonitor}) => {
  const [instructions, setInstructions] = useState()
  const width = useWidth()

  useEffect(() => {
    fetchInstructions()
  }, [sendBPmonitor])


  const fetchInstructions = () => {
    const instructions = [{
      sections: [
        {
        title: <>Receive the {sendBPmonitor ? `Biobeat Chest Monitor + calibrating blood pressure monitor` : `Biobeat Chest Monitor`} </>,
        description: <>You'll get it in the mail within 1 week. You'll need to calibrate it with 3 readings using a traditional blood pressure monitor.</>
      }, 
    ]}, 
    {
      sections: [{
        title: 'Wear the Biobeat Chest Monitor for 24 hours',
        description: <>Using an adhesive, it's easy and comfortable to wear on your chest. Try to choose a day when you can avoid showering. The monitor will gather the cardiac metrics.</>
      }]
    }, 
    {
      sections: [{
        title: 'Get Test Results & Recommendations ',
        description: <>When done, the data will be sent to Instalab. A physician will review your cardiac data and provide a report with recommendations to improve your heart health.</>
      }]
    }]

    setInstructions(instructions)

  }
  return (
    <div className="prescription-approval">


      {instructions?.length > 0 && (
        <div className="instruction-list">
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>
      )}

      <Button
        className="question-btn"
        onClick={() => window.FrontChat("show")}
      >
        I have a question?
      </Button>

      <LatestPosts />
    </div>
  )
}

